'use client'

import Footer from '@/components/landing-page/footer'
import { footerData } from '@/data/landing-page/footerData'

import { Box, Text } from '@chakra-ui/react'

export default function DataUsage() {
  return (
    <div className="bg-white">
      <Box
        margin={'auto'}
        maxW={'92%'}
        position={'relative'}
        className="w-full"
      >
        <br />
        {/* <Text fontSize={22} fontWeight={600} color={'lyk-green'}>
          FAQs
        </Text> */}
        <br />
        <Text fontSize={45} fontWeight={600}>
          Disclosure about Data Usage
        </Text>

        <div className="mt-4">
          <div className="font-semibold">Your privacy is important to us</div>
          <p className="mt-2">
            Please take time to review the key points of our Privacy Policy and
            T&C below
          </p>
          <p>
            At LYKSTAGE, we value your trust and are committed to being
            transparent about how we use your data when you use our video
            sharing platform. This Data Usage Disclosure explains how we
            collect, process, and protect your information. By using our
            platform, you consent to the practices described in this document.
          </p>

          <div className="mt-4 font-semibold">Data we process</div>
          <p className="mt-2">
            We are committed to safeguarding the privacy of our users and deeply
            value the data you entrust to us. We handle and process your data
            securely in accordance with our Privacy Policy. The specific data we
            process depends on how you utilize our web application.
          </p>
          <p>
            Initially, we only require your name, email, gender, country,
            language, and interests to create your profile. Additionally, we
            offer optional features that, if you choose to use them, may
            necessitate the collection of additional information.
          </p>
          <p>
            When you begin using our application, we will also gather
            information about your interactions with our platform and the
            devices you use to access it, including details such as your IP
            address, device location, and unique identifiers.
          </p>
        </div>

        <div className="mt-4">
          <div className="font-semibold">How we use your data</div>
          <p className="mt-2">
            Privacy is fundamental to our culture and processes at LYKSTAGE. We
            continuously assess the privacy implications of all our features.
            Your data is solely used for the purposes outlined in our Privacy
            Policy, including but not limited to:
          </p>
          <ul className="mt-2 list-inside list-disc">
            <li>
              Displaying your channel and uploaded videos when another user
              searches for your channel or name
            </li>
            <li>
              Providing, enhancing, analyzing, and personalizing our services to
              ensure a positive experience on our application
            </li>
            <li>Adhering to local laws and safeguarding your rights</li>
            <li>
              Generating reports using aggregated and anonymized data for
              statistical and analytical purposes to enhance our services. We
              collect only the necessary information to provide our services
            </li>
            <li>
              Avoiding excessive data collection that is not directly related to
              our service
            </li>
            <li>
              Clearly communicating your data collection and usage practices in
              a privacy policy
            </li>
            <li>
              Obtaining explicit consent from users before collecting and
              processing their data
            </li>
            <li>
              Collecting data about how you use our platform, including the
              videos you watch, your interactions with content, and the duration
              of your sessions
            </li>
            <li>
              Technical information, such as your device type, browser, and
              operating system
            </li>
            <li>
              To deliver and improve our video sharing platform, including
              personalizing content recommendations, related videos, and your
              home feed recommendations
            </li>
            <li>
              To send you important updates, notifications, and marketing
              materials, as permitted by applicable laws
            </li>
            <li>
              To analyze and improve our platform, including understanding user
              behavior and preferences
            </li>
            <li>
              To comply with legal obligations, resolve disputes, and enforce
              our Terms of Service
            </li>
            <li>
              Protecting against fraud, security breaches, and technical issues
            </li>
            <li>We do not share your data with third parties.</li>
          </ul>
        </div>

        <div className="mt-4">
          <div className="font-semibold">
            We empower you on how like to be seen on LYKSTAGE
          </div>
          <p className="mt-2">
            We empower you to control and safeguard your personal and account
            information. You have the authority to determine how your personal
            information is presented to others in the community. You can edit
            your profile visibility settings within the application at any time.
          </p>
          <ul className="mt-2 list-inside list-disc">
            <li>
              You can update or delete your account information at any time.
            </li>
            <li>You may unsubscribe from marketing communications.</li>
            <li>
              You can configure your device settings to limit data collection
              (e.g., disabling location services or cookies).
            </li>
          </ul>
        </div>

        <div className="mt-4">
          <div className="font-semibold">
            We never request unnecessary permissions
          </div>
          <p className="mt-2">
            The realm of communication is becoming increasingly intricate with
            each passing day. However, we are dedicated to enhancing the
            intelligence, security, and efficiency of your communication.
            Consequently, we aim to ensure that you have a complete
            understanding of the permissions required for LYKSTAGE to operate
            according to your preferences.
          </p>
          <p className="mt-2">
            It is crucial that you have a clear understanding of how we utilize
            your data. You always have the option to deactivate these
            permissions within the application.
          </p>
        </div>

        <div className="mt-4">
          <div className="font-semibold">
            Your personal details are always confidential
          </div>
          <p className="mt-2">
            Privacy is a fundamental principle at LYKSTAGE. Our search feature
            displays channel names, videos, and public profile information that
            you have chosen to share. This approach ensures that your identity
            remains private.
          </p>
          <div className="mt-4 font-semibold">Data Security</div>
          <p className="mt-2">
            We take the security of your data seriously. We implement reasonable
            safeguards to protect your information from unauthorized access,
            disclosure, alteration, and destruction.
          </p>
          <div className="mt-4 font-semibold">Service Providers</div>
          <p className="mt-2">
            We work with trusted third-party service providers who help us
            operate and improve our platform. They are bound by confidentiality
            and security obligations.
          </p>
          <div className="mt-4 font-semibold">Legal Compliance</div>
          <p className="mt-2">
            When required by law, we may share your information with law
            enforcement or other governmental authorities.
          </p>
          <div className="mt-4 font-semibold">Children&apos;s Privacy</div>
          <p className="mt-2">
            Our platform is not intended for children under the age of 13. We do
            not knowingly collect data from children under this age. If you
            believe a child has provided us with their information, please
            contact us.
          </p>
        </div>

        <div className="mt-4">
          <div className="font-semibold">Changes to this Disclosure</div>
          <p className="mt-2">
            We may update, without prior notice, this Data Usage Disclosure to
            reflect changes in our practices. We will notify you of any
            significant changes via email or by prominently notifying on our
            platform.
          </p>
          <p className="mt-2">
            By using our video platform, you acknowledge, agree and consent to
            the practices described in this Data Usage Disclosure along with
            other T&Cs.
          </p>
          <p className="mt-2">
            If you have any questions or concerns about your data, please
            contact our Customer Support.
          </p>
          <p className="mt-2">
            LYK Inc
            <br />
            913 N. Market Street, Suite 300, Wilmington, DE 19801
            <br />
            legal@lykstage.com
          </p>
        </div>

        <br />

        <br />
        <br />
      </Box>

      <section>
        <Footer />
      </section>
    </div>
  )
}
